import React, { useCallback } from 'react';
import { Input } from 'antd';
import type { InputNode } from '../types';
import { RequiredMark } from './RequiredMark';

type Props = {
  node: InputNode;
  value: string | undefined;
  onChange: (key: string, value: string) => void;
  disabled?: boolean;
  error?: string;
  nodeDefaults?: { textarea?: { maxHeight?: number } };
};

/**
 * V1 结构（textarea/render.ts）：
 *   <div class="rte-textarea-wrapper" data-key=...>
 *     <textarea class="rte-textarea"></textarea>
 *   </div>
 */
export const TextareaNode: React.FC<Props> = React.memo(
  ({ node, value, onChange, disabled, error, nodeDefaults }) => {
    const maxHeight =
      typeof node.maxHeight === 'number'
        ? node.maxHeight
        : nodeDefaults?.textarea?.maxHeight ?? 252;
    const handle = useCallback(
      (e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(node.key!, e.target.value),
      [node.key, onChange],
    );
    return (
      <RequiredMark node={node}>
      <div
        className={`rte-textarea-wrapper ${error ? 'rte-textarea-error' : ''}`}
        data-key={node.key}
      >
        <Input.TextArea
          className="rte-textarea"
          data-type="textarea"
          data-key={node.key}
          value={value ?? ''}
          onChange={handle}
          disabled={disabled}
          placeholder={node.placeholder}
          autoSize={{ minRows: 1, maxRows: 99 }}
          style={{ maxHeight }}
          variant="borderless"
        />
      </div>
      </RequiredMark>
    );
  },
);
TextareaNode.displayName = 'TextareaNode';
